import { IConsultationRequestInboxModel } from "../UI/IConsultationRequestsInboxModel";
import { ILabRequestsInboxModel } from "../UI/IRequestsInboxModel";

class MedicalRequestsInboxSettings {
    public IsAllSitesChecked: boolean;
    public IsAllCreatedByClinicianChecked: boolean;
    public IsAllRequestingStaffChecked: boolean;
    public IsAllStatusChecked: boolean;
    public IsAllPriorityChecked: boolean;
    public SiteIds: string[];
    public RequestingStaffIds: string[];
    public CreatedByCliniciansIds: string[];
    public Statuses: string[];
    public Priorities: string[];
    public PageSize: number;

    public constructor(init?: Partial<MedicalRequestsInboxSettings>) {
        Object.assign(this, init);
    }

    public static fromModel(model: ILabRequestsInboxModel | IConsultationRequestInboxModel): MedicalRequestsInboxSettings {
        return new MedicalRequestsInboxSettings({
            IsAllSitesChecked: model.get("SelectAllSitesChecked"),
            IsAllCreatedByClinicianChecked: model.get("SelectAllCreatedByChecked"),
            IsAllRequestingStaffChecked: model.get("SelectAllRequestingStaffChecked"),
            IsAllStatusChecked: model.get("SelectAllStatusChecked"),
            IsAllPriorityChecked: model.get("SelectAllPriorityChecked"),
            SiteIds: model.get("Sites").filter(site => site.Checked).map(site => site.Id).toArray(),
            RequestingStaffIds: model.get("RequestingStaffGlobalCache").filter(staff => staff.Checked).map(staff => staff.ContactFacetId).toArray(),
            CreatedByCliniciansIds: model.get("CreatedByGlobalCache").filter(clinician => clinician.Checked).map(clinician => clinician.ContactFacetId).toArray(),
            Statuses: model.get("StatusList").filter(status => status.Checked).map(status => status.Id).toArray(),
            Priorities: model.get("PriorityList").filter(priority => priority.Checked).map(priority => priority.Id).toArray(),
            PageSize: model.get("SelectedPageSizeOption")
        });
    }
}

export { MedicalRequestsInboxSettings };
